import React, { forwardRef } from 'react'
import cn from 'classnames'
import s from './input.module.css'
import type { InputProps } from './types'

const Input = (props: InputProps, ref: any) => {
  const { className, name, inputClassName, pure = false, ...rest } = props

  if (pure) {
    return <input className={cn(s.input, inputClassName)} ref={ref} name={name} {...rest} />
  }

  const { label, touched, error, ...prop } = rest

  return (
    <label htmlFor={name} className={cn(s.root, className)}>
      {label && <span className={s.label}>{label}</span>}
      <input className={cn(s.input, inputClassName)} ref={ref} name={name} {...prop} />
      <span className={s.alert} role="alert">
        {error || null}
      </span>
    </label>
  )
}

export default forwardRef(Input)
